import { phone } from 'phone';

export const parsePhoneFromString = input => {
  const inputNumber = input == null ? '' : input.trim();

  if (inputNumber.startsWith('+')) {
    const { isValid, phoneNumber, countryCode, countryIso2 } = phone(
      inputNumber
    );
    return {
      value: isValid ? phoneNumber : inputNumber,
      isValid,
      country: { dial: countryCode, code: countryIso2 }
    };
  } else if (inputNumber.startsWith('00')) {
    const { isValid, countryCode, countryIso2 } = phone(
      '+' + inputNumber.substring(2)
    );
    return {
      value: inputNumber,
      isValid,
      country: { dial: countryCode, code: countryIso2 }
    };
  }
  return {
    value: inputNumber,
    isValid:
      inputNumber.length >= 6 &&
      inputNumber.length <= 20 &&
      /[0-9]/.test(inputNumber),
    country: { dial: null, code: null }
  };
};

export const parsePhoneWithNewCountry = (inputPhone, newIso, newDial) => {
  const data = parsePhoneFromString(inputPhone);
  const { country, value } = data;

  if (country.dial) {
    if (value.startsWith('+')) {
      const newValue = value.replace(country.dial, newDial);

      return {
        value: newValue,
        isValid: parsePhoneFromString(newValue).isValid,
        country: { dial: newDial, code: newIso }
      };
    } else if (value.startsWith('00')) {
      const oldDialNumber = country.dial.replace('+', '');
      const newDialNumber = newDial.replace('+', '');
      const newValue = value.replace(
        `00${oldDialNumber}`,
        `00${newDialNumber}`
      );

      return {
        value: newValue,
        isValid: parsePhoneFromString(newValue).isValid,
        country: { dial: newDial, code: newIso }
      };
    }
  }
  return data;
};

export const onPhoneKeyPress = event => {
  const keyCode = event.keyCode || event.which;
  const keyValue = String.fromCharCode(keyCode);
  if (!/[+0-9]/.test(keyValue)) event.preventDefault();
};
